import { useMutation } from "react-query";
import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { PlantDock } from "../PlantDock";
import { plantDockUrls } from "../../URL/ApplicationUrls";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";
import { updateSuccessMessage } from "../../Messages/successMessages";
import { combinedUrls } from "../../URL/functions";

export const useUpdateDock = () => {
  return useMutation({
    mutationFn: (dock: PlantDock) => {
      return axios.put<PlantDock>(
        combinedUrls(plantDockUrls.docksForPlantWithId(dock.PlantId), dock.Id.toString()),
        dock
      );
    },
    onSuccess: async (response: AxiosResponse<PlantDock>) => {
      toast.success(updateSuccessMessage(response.data.Id, "Dock"));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
